import * as yup from "yup";
export const AddOnsCombineSetupValidationSchema = yup.object({});
